import { FilterTemplateListItemContent } from '../FilterTemplateListItemContent'
import { ListItem } from '../ListItem'

function FilterTemplateListItem(props) {
  return <ListItem {...props} Content={FilterTemplateListItemContent} />
}

export default FilterTemplateListItem
